// removed by extract-text-webpack-plugin
module.exports = {"checklistTemplateDetailHeader":"ChecklistTemplateDetailHeader__checklistTemplateDetailHeader__VjUbs","backToOverview":"ChecklistTemplateDetailHeader__backToOverview__cIbvp","icon":"ChecklistTemplateDetailHeader__icon__3nUuO"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/ChecklistTemplateDetailView/ChecklistTemplateDetailHeader/ChecklistTemplateDetailHeader.scss
// module id = 1767
// module chunks = 0